module.exports = __webpack_public_path__ + "static/img/index_bg.bcaa64c.bcaa64c.png";


//////////////////
// WEBPACK FOOTER
// ./src/OK_Scott/assets/image/index_bg.bcaa64c.png
// module id = m3OZ
// module chunks = 1